// extracted by mini-css-extract-plugin
module.exports = {"app":"wrapper-module--app--KFo-b","wrapper":"wrapper-module--wrapper--1RT9C"};